import { render, staticRenderFns } from "./AuditLogDetail.vue?vue&type=template&id=37231f90&scoped=true&"
import script from "./AuditLogDetail.vue?vue&type=script&lang=js&"
export * from "./AuditLogDetail.vue?vue&type=script&lang=js&"
import style0 from "./AuditLogDetail.vue?vue&type=style&index=0&id=37231f90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37231f90",
  null
  
)

export default component.exports